import React from 'react';

import { IMAGE_EMPTY_PHOTO_PORTRAIT } from 'common/configuration/constants';
import { path } from 'common/tools/network/routing';
import { getImageUrl } from 'common/tools/network/url';
import trans from 'common/tools/translations/trans';

import WantToSeeButton from 'website/components/WantToSeeButton';
import StandaloneRating from 'website/components/push/Ratings/StandaloneRating';
import { Entity } from 'website/types';

import BaseItem, { Props as BaseItemProps } from './BaseItem';
import SuggestionImage, {
  Props as SuggestionImageProps
} from './SuggestionImage';
import SuggestionLink from './SuggestionLink';
import styles from './styles.module.scss';

type Props = Pick<BaseItemProps, 'className'> &
  Pick<SuggestionImageProps, 'lazy'> & {
    entity: Entity;
  };

const AffinitySuggestionsItem = (props: Props) => {
  const imageUrl = getImageUrl({
    src:
      'poster' in props.entity && props.entity.poster
        ? props.entity.poster
        : IMAGE_EMPTY_PHOTO_PORTRAIT,
    format: { cw: 216, ch: 288 }
  });

  const title = 'title' in props.entity ? props.entity.title : undefined;

  const routePath =
    props.entity.typename == 'Movie'
      ? path('moviepage', { movie: props.entity.legacyId })
      : path('seriespage', { series: props.entity.legacyId });

  return (
    <BaseItem className={props.className}>
      <SuggestionLink href={routePath}>
        <SuggestionImage title={title} lazy={props.lazy} src={imageUrl} />
        <div className={styles.suggestionTitle} title={title}>
          {title}
        </div>
      </SuggestionLink>
      <StandaloneRating
        showDeleteRating={false}
        size="large"
        entityId={props.entity.id}
        socialActionPlacement="actions_booster"
      />
      <WantToSeeButton
        theme="social-ac"
        type="ghost"
        size="sm"
        entityId={props.entity.id}
        socialActionPlacement="actions_booster"
      >
        {trans('bam.push.want-see-yes')}
      </WantToSeeButton>
    </BaseItem>
  );
};

export default AffinitySuggestionsItem;
